import { useGetMe } from '@/api/user.api';
import { useTranslation } from '@/i18n';
import { DistributorKind } from '@/types/auth/DistributorKind';

export const useDistributorLabels = () => {
  const { t } = useTranslation();
  const { data: userData, isSuccess } = useGetMe();

  const isTourOperator =
    isSuccess && userData?.agency?.kind === DistributorKind.TourOperator;

  const ns = isTourOperator ? 'distributorAgencies' : 'clients';

  const tPages = (key: string) =>
    t(isTourOperator ? `distributorAgencies.${key}` : `pages.clients.${key}`);

  return {
    isTourOperator,
    tLabel: (key: string) => t(`${ns}.${key}`),
    tPages,
    tNavbar: () => t(isTourOperator ? 'navbar.agencies' : 'navbar.clients'),
    tProject: (key: string) =>
      t(isTourOperator ? `distributorProjects.${key}` : `project.${key}`),
  };
};
